module.exports = __webpack_public_path__ + "static/media/optimize.07b6cc73.png";